import { FetchParameters, FetchQuery } from "../types/api.types";
import { SearchResultResponse } from "../types/search.types";

const URL =
  process.env.LANG === "cn" ? process.env.API_URL_CN! : process.env.API_URL!;

export const RESULTS_PER_PAGE = "5";
export const MAX_RESULTS = "5";

export class ApiService {
  public url: string;
  public page: number;
  public results: SearchResultResponse;
  public resultsPerPage: number;
  public maxResults: number;
  public numberOfResults: number;
  public params: FetchQuery;

  constructor(options?: { resultsPerPage?: number; maxResults?: number }) {
    this.url = URL;
    this.page = 0;
    this.resultsPerPage = options?.resultsPerPage || parseInt(RESULTS_PER_PAGE);
    this.maxResults = options?.maxResults || parseInt(MAX_RESULTS);
    this.params = "";
    this.numberOfResults = 0;
  }

  public async getResults() {
    try {
      const response = await fetch(`${this.url}?${this.params}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      this.results = this.filterNullValues(data);
      this.restrictToMaxResults();

      return this.results;
    } catch (error) {
      throw new Error(error as any);
    }
  }

  public restrictToMaxResults() {
    if (this.results.searchResults.length > this.maxResults) {
      this.results.searchResults = this.results.searchResults.slice(
        0,
        this.maxResults
      );
    }
  }

  public createSearchParams(userParams?: Partial<FetchParameters>) {
    if (!userParams) {
      return;
    }

    Object.keys(userParams).forEach((key) => {
      const value = userParams[key];

      if (value && value.constructor === Array && value.length === 0) {
        delete userParams[key];
      }
    });

    const searchParams = new URLSearchParams(userParams as any).toString();

    this.params = searchParams;
  }

  public filterNullValues(results: SearchResultResponse) {
    if (!results.searchResults) {
      return results;
    }

    const filteredResults = results.searchResults.filter((item) => {
      let noNullValue = true;

      Object.keys(item).forEach((key) => {
        if (item[key] === null) {
          noNullValue = false;
        }
      });

      return noNullValue;
    });

    return { ...results, searchResults: filteredResults };
  }
}
